var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overview-layout',{ref:"overview",attrs:{"tableCfg":_vm.tableCfg,"fixedFilter":_vm.viewFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }